import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

import {
  GET_DUPLICATION_RULE_LIST_API,
  ADD_DUPLIACATE_RULE_API,
  UPDATE_DUPLIACATE_RULE_API,
  DOWNLOAD_EXCEL_DUPLICATION_RULE_API,
} from '../endpoints/apiEndpoints'


export const getDuplicationRule = async (payload,tandID) => {
  const url = urlBuilder(GET_DUPLICATION_RULE_LIST_API,{tandID})
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const addDuplicationRule = async (payload) => {
  const url = urlBuilder(ADD_DUPLIACATE_RULE_API)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const updateDuplicationRule = async (payload,uuid) => {
  const url = urlBuilder(UPDATE_DUPLIACATE_RULE_API,{uuid})
  const requestHeader = buildRequestHeader('PUT', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadDuplicationRule = async (payload,tandID) => {
  const url = urlBuilder(DOWNLOAD_EXCEL_DUPLICATION_RULE_API,{tandID})
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}


